import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../utils/colors';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const HomePage = () => {
  // Use our custom hook
  useRandomLinkColors();
  const [imageLoaded, setImageLoaded] = useState(false);
  // Ensure header links get random colors on initial render
  useEffect(() => {
    const headerLinks = document.querySelectorAll('header a');
    headerLinks.forEach(link => {
      // Always apply a random color on initial render, regardless of data-color-applied attribute
      link.style.color = getRandomColor();
      link.dataset.colorApplied = 'true';
    });
  }, []);
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-222" data-mp="e2o6r2mltrf9">
      <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-50" data-id="element-223" data-mp="931uavelof7i">
        <div className="flex space-x-6" data-id="element-224" data-mp="955vv6p1124m">
          <div className="text-base font-normal" data-id="element-225" data-mp="50y9hg61jy9k">Madeleine Morlet</div>
          <div className="text-base font-normal" data-id="element-226" data-mp="1hhengkp8rktq">
            <Link to="/info" className="transition-colors duration-200"
          // Apply random color directly in the JSX to ensure it's visible
          style={{
            color: getRandomColor()
          }} data-color-applied="true" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = getRandomColor(); // Use random color on leave too
          }} data-id="element-227" data-mp="1hgmrh8rqfl2x">
              Info
            </Link>
          </div>
        </div>
      </header>
      <main className="min-h-screen flex justify-center" data-id="element-228" data-mp="1v8jgv520ngvm">
        <div className="w-full max-w-md px-6 pt-32 pb-24 md:pt-40 md:pb-32" data-id="element-229" data-mp="1v6zztc8jd1ss">
          {/* Empty loading placeholder without text */}
          {!imageLoaded && <div className="w-full aspect-[4/3] bg-gray-50 border border-gray-100 flex items-center justify-center" data-id="element-230" data-mp="jupe1ps7m5xu"></div>}
          {/* Image on top, text below */}
          {imageLoaded && <div className="relative" data-id="element-231" data-mp="2hi9sgjuze9im">
              {/* Image at the top */}
              <div className="mb-4" data-id="element-232" data-mp="2cq06tg0wfvm5">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qUj4p6NCfXo8eW89Phqk6D/Madeleine_Morlet_13.jpg" alt="Rainbow over water with silhouettes of trees" className="w-full h-auto border border-gray-200 shadow-sm" loading="eager" width="800" height="600" data-id="element-233" data-mp="2coxed3nxhl44" />
                <div className="text-xs italic mt-2 ml-1" data-id="element-234" data-mp="1ts5vuwg7na14">* image</div>
              </div>
              {/* Text below the image */}
              <div className="bg-[#faf9f7] mt-10" data-id="element-235" data-mp="3o5oqnyiuweiq">
                <p className="text-sm m-0" style={{
              lineHeight: '1.7'
            }} data-id="element-236" data-mp="3o4dp85cvvius">
                  Not long after returning from Los Angeles, in those liminal
                  months before we move from the States back to London, I buy a
                  set of eight farmhouse chairs off Facebook Marketplace. It's
                  the start of September and it's blistering hot, humid too. The
                  air is too wet to breathe. I plan to drive over an hour
                  through country roads to a strip mall carpark for the
                  exchange. My phone has ten percent battery, the charger in the
                  truck is broken, as is the power steering, the right front
                  tyre is letting out air, and the air conditioner is stuck on
                  hot. I need to have the windows closed to hear the sat nav,
                  and I am sweating bullets. After I load the chairs onto the
                  truck, it starts to bucket down—those thick, heavy droplets
                  that come with high humidity. The truck is hydroplaning and my
                  whole body prickles with adrenaline. I am driving down a
                  mountain on a newly resurfaced road that curves dramatically,
                  on either side of me, an incline and decline of evergreen. A
                  patch of sun breaks through the dark sky and I see a rainbow
                  forming ahead, rolling down the mountain, across the road, and
                  into the forest. I drive through that rainbow.{' '}
                  <em data-id="element-237" data-mp="2ov08a1ob4dtu">Through the actual rainbow</em>. For what feels like
                  minutes, I am <em data-id="element-238" data-mp="2ot5x3f2u802y">inside colour</em>. The truck fills with red
                  and blue and yellow and green and violet as if all at once. I
                  Google it later and, according to the laws of physics, it's
                  impossible.
                </p>
                <div className="text-xs italic mt-4 ml-1" data-id="element-239" data-mp="3cl2uw29gcrl2">* text</div>
              </div>
            </div>}
          {/* Hidden image to trigger onLoad before render */}
          {!imageLoaded && <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qUj4p6NCfXo8eW89Phqk6D/Madeleine_Morlet_13.jpg" alt="" className="hidden" onLoad={() => setImageLoaded(true)} data-id="element-240" data-mp="3r81j7od0j5vk" />}
        </div>
      </main>
    </div>;
};
export default HomePage;